import React from 'react';
import styles from '../ExportToFile.module.scss';
import { Message, Text, Link } from 'components/core';

type Props = {
  moreInfoTarget: string;
};

export const BiasWarning = ({ moreInfoTarget }: Props): JSX.Element => (
  <Message
    type="warning"
    variant="prominent"
    dismissible={false}
    className={styles.warning}
  >
    <Text size="xs">
      This export has individual reviewer data which may introduce bias in your
      review.{' '}
      <Link to={moreInfoTarget} variant="brand" external>
        <strong>Learn more</strong>
      </Link>
    </Text>
  </Message>
);
